module.exports = __webpack_public_path__ + "img/sucuri.61a0331d.png";